const toNumber = (value, fallback = 0) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const roundHalfToEven = (value) => {
  const num = toNumber(value, 0);
  const sign = num < 0 ? -1 : 1;
  const abs = Math.abs(num);
  const floor = Math.floor(abs);
  const diff = abs - floor;

  if (diff > 0.5) {
    return sign * (floor + 1);
  }
  if (diff < 0.5) {
    return sign * floor;
  }
  return sign * (floor % 2 === 0 ? floor : floor + 1);
};

export const formatNumberId = (value) =>
  roundHalfToEven(value).toLocaleString("id-ID", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

export const formatStockValue = (value) => toNumber(value, 0).toFixed(1);

export const formatRupiah = (value) => `Rp ${formatNumberId(value)}`;
